export const getAnalyticOrdinalNumbers = (analyticsList) => {
  const seenCount = {};

  return analyticsList?.map((analytic) => {
    const type = analytic.analytic_name ?? analytic;
    const current = (seenCount[type] || 0) + 1;
    seenCount[type] = current;
    return current;
  });
};
